module.exports = __webpack_public_path__ + "img/application_bg3_m.a8536c94.jpg";